import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recordDetails: {},
  isLoadingRecordDetails: false,
  activeKey: "",
  isOpenList: false,
  dataList: [],
};

const slice = createSlice({
  name: "consolidatedView",
  initialState,
  reducers: {
    getRecordDetails(state) {
      state.isLoadingRecordDetails = true;
    },
    getRecordDetailsResult(state, action) {
      state.recordDetails = action.payload;
      state.isLoadingRecordDetails = false;
    },
    setActiveKey(state, action) {
      state.activeKey = action.payload;
    },
    setIsOpenList(state, action) {
      state.isOpenList = action.payload;
    },
    setDataList(state, action) {
      state.dataList = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  getRecordDetails,
  getRecordDetailsResult,
  setActiveKey,
  setIsOpenList,
  setDataList,
} = slice.actions;
